import { createFileRoute } from '@tanstack/react-router'
import { Separator } from '@/components/ui/separator'
import { SidebarTrigger } from '@/components/ui/sidebar'
import { AppLayout } from '@/components/layout/app-layout'
import { IcpFooter } from '@/components/layout/icp-footer'
import { Main } from '@/components/layout/main'
import { ThemeSwitch } from '@/components/theme-switch'
import { AnnouncementButton } from '@/features/announcements'
import { AuthButton } from '@/features/auth/index'
import { Discover, SearchBar, Tags } from '@/features/discover'
import { DiscoverHeader } from '@/features/discover/components/discover-header'
import { discoverQueryOptions } from '@/features/discover/hooks/use-discover'
import { useDiscoverStore } from '@/features/discover/stores/discover-store'

export const Route = createFileRoute('/')({
  loader: async ({ context }) => {
    const { searchQuery, category, sort, tags, limit } =
      useDiscoverStore.getState().searchParams

    await context.queryClient.ensureInfiniteQueryData(
      discoverQueryOptions({
        searchQuery,
        category,
        sort,
        tags,
        limit,
      })
    )
  },
  component: Findings,
})

export function Findings() {
  return (
    <AppLayout>
      {/* h-auto: 让高度随内容自适应，或者保留 h-30 并配合 p-4 
        flex-col: 确保两行纵向排列
      */}
      <DiscoverHeader className='flex h-auto flex-col gap-4'>
        {/* 第一行：侧边栏 + 分割线 + 搜索 + 认证 */}
        <div className='flex w-full items-center gap-3 sm:gap-4'>
          {/* 左侧：侧边栏开关 */}
          <div className='flex shrink-0 items-center gap-2 sm:gap-4'>
            <SidebarTrigger variant='outline' />
            <Separator orientation='vertical' className='h-6' />
          </div>

          {/* 中间：主搜索框，占据剩余空间 */}
          <div className='flex min-w-0 flex-1 justify-start'>
            <SearchBar className='w-full max-w-2xl' />
          </div>

          {/* 右侧：认证与其它操作 */}
          <div className='flex shrink-0 items-center gap-2 sm:gap-3'>
            <ThemeSwitch />
            <AnnouncementButton />
            <AuthButton />
          </div>
        </div>

        {/* 第二行：Tags 标签栏 */}
        <div className='w-full overflow-hidden'>
          <Tags />
        </div>
      </DiscoverHeader>

      <Main fluid className='p-0 pb-8'>
        <Discover />
      </Main>

      <IcpFooter />
    </AppLayout>
  )
}
